/** * Created by lobin on 2019/1/12. */
<template>
  <div class="register clearfix">
    <div class="login-left"></div>
    <div class="login-right">
      <div class="login-content">
        <h2 class="register-title">注册</h2>
        <div class="register-form">
          <el-form
            :model="form"
            :rules="rules"
            ref="regForm"
            label-width="100px"
            class="register-form-wraper"
            status-icon
            label-position="left"
            size="small"
            @keyup.enter.native="submit"
          >
            <el-form-item label="手机号" prop="mobile">
              <el-input
                v-model="form.mobile"
                placeholder="请输入手机号"
              ></el-input>
            </el-form-item>
            <el-form-item label="密码" prop="password">
              <el-input
                v-model="form.password"
                type="password"
                placeholder="请输入密码"
              ></el-input>
            </el-form-item>
            <el-form-item label="确认密码" prop="repassword">
              <el-input
                v-model="form.repassword"
                type="password"
                placeholder="请输入确认密码"
              ></el-input>
            </el-form-item>
            <el-form-item label="图形验证码" prop="imageCaptcha">
              <el-input v-model="form.imageCaptcha">
                <template slot="append">
                  <div class="captcha-wraper">
                    <img
                      :src="`${captcha + id}`"
                      alt="验证码"
                      @click="getNewCaptchaId"
                    />
                    <div class="captchaLoading" v-if="captchaLoading">
                      加载中...
                    </div>
                  </div>
                </template>
              </el-input>
            </el-form-item>
            <el-form-item label="短信验证码" prop="smsCaptcha">
              <el-input v-model="form.smsCaptcha">
                <template slot="append">
                  <el-button
                    type="text"
                    @click="sendVcodeAction"
                    :loading="vcodeSending"
                  >
                    <i v-if="this.s > 0">{{ this.s }}s后重新发送短信</i>
                    <i v-else>{{
                      vcodeSending ? "正在获取验证码" : "获取验证码"
                    }}</i>
                  </el-button>
                </template>
              </el-input>
            </el-form-item>
            <el-button
              type="primary"
              class="register-form-btn"
              :loading="loading"
              @click="submit"
              :disabled="!checked"
              >提交注册</el-button
            >
            <p class="register-form-des">
              <el-checkbox v-model="checked"
                >我已同意<a
                  href="/index/userAgreement"
                  target="_blank"
                  @click="checked = true"
                  >《用户协议》</a>
                  <a
                  href="/index/privacy"
                  target="_blank"
                  @click="checked = true"
                  >《隐私政策》</a
                ></el-checkbox
              >
              已有账号，去<router-link tag="a" to="/login">登录</router-link>
            </p>
          </el-form>
        </div>
      </div>
    </div>
    <!-- 注册成功的跳转提示 -->
    <el-dialog
      :visible.sync="registerSuccessful"
      :show-close="false"
      width="30%"
      center
    >
      <p style="text-align:center;">
        恭喜您，注册成功，即将跳转登录,{{ countdown }}s后自动跳转登陆
      </p>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="goLogin">去登陆</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script type="text/babel">
import { mapActions, mapState } from "vuex";
// import { base64 } from "../../libs/utilts";
import { getLoadings } from "../../libs/vuex-loading/index";
import { regular } from "../../libs/utilts";
export default {
  data() {
    return {
      captchaLoading: false,
      checked: false,
      id: "",
      s: 0,
      form: {
        email: "",
        mobile: "",
        password: "",
        repassword: "",
        captchaHashing: "",
        imageCaptcha: "",
        smsCaptcha: ""
      },
      registerSuccessful: false, //注册成功之后的倒计时弹窗
      countdown: 5 //倒计时跳转登陆
    };
  },
  created() {
    this.getNewCaptchaId();
  },
  computed: {
    ...getLoadings(loadings => ({
      loading: loadings.action("register"),
      vcodeSending: loadings.action("sendVcode")
    })),
    ...mapState({
      captcha: state => state.user.captcha
    }),
    rules() {
      const comparePassword = (rule, value, callback) => {
        if (value !== this.form.password) {
          return callback(new Error("两次输入的密码不一致"));
        }
        if (!value) {
          return callback(new Error("请再次输入密码"));
        }
        callback();
      };
      return {
        mobile: [
          { required: true, trigger: "change", validator: this.validatorPhone }
        ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
        repassword: [
          { required: true, trigger: "change", validator: comparePassword }
        ],
        imageCaptcha: [
          { required: true, message: "请输入图像验证码", trigger: "blur" }
        ],
        smsCaptcha: [
          { required: true, message: "请输入短信验证码", trigger: "blur" }
        ]
      };
    }
  },
  methods: {
    ...mapActions(["register", "checkMobile", "sendVcode"]),
    async validatorPhone(rule, value, callback) {
      const phoneReg = regular.phone;
      // 验证手机号码
      let phoneEx = false;
      if (value && phoneReg.test(value)) {
        phoneEx = await this.checkMobile(value);
      }
      if (!value) {
        return callback(new Error("用户名不能为空!!"));
      }
      if (!phoneReg.test(value)) {
        return callback(new Error("电话号码不符合规则"));
      } else if (phoneEx.data) {
        return callback(new Error("此用户已经存在"));
      } else {
        callback();
      }
    },
    getNewCaptchaId() {
      this.captchaLoading = true;
      this.id = Math.random();
      // 模拟一个loading
      setTimeout(() => {
        this.captchaLoading = false;
      }, 1500);
    },
    async sendVcodeAction() {
      if (this.s > 0) return ;

      const captchaHashing = this.id;
      const captcha = this.form.imageCaptcha;
      const mobile = this.form.mobile;
      const phoneEx = await this.checkMobile(mobile);
      if (phoneEx.data) return this.$message.error("账号已经注册");
      const data = await this.sendVcode({
        captcha,
        captchaHashing,
        mobile,
        smsTemplateType: "REGIST"
      });
      if (data.code===200) {
        this.$message.success("验证码发送成功，请注意查收!");
        this.s = 60;
        this.timer = setInterval(() => {
          this.s--;
          if (this.s === 0) {
            clearInterval(this.timer);
          }
        }, 1000);
      } else {
        this.$message.error(data.message);
      }
    },
    async submit() {
      if (!(await this.$refs.regForm.validate())) return;
      const { data } = await this.register({
        email: "",
        mobile: this.form.mobile,
        password: this.form.password,
        captchaHashing: this.id,
        imageCaptcha: "",
        smsCaptcha: this.form.smsCaptcha
      });
      if (data) {
        // this.$message.success("注册成功");
        window.localStorage.setItem("token", data.accessToken);
        this.registerSuccessful = true;
        this.countdownFun();
        // await this.getInitDate();
        // this.$router.push('/login');
      }
    },
    // 去登陆
    goLogin() {
      this.registerSuccessful = false;
      this.$router.push("/login");
    },
    // 倒计时
    countdownFun() {
      const countdown = setInterval(() => {
        this.countdown--;
        if (this.countdown === 0) {
          clearInterval(countdown);
          this.$router.push("/login");
        }
      }, 1000);
    }
  },
  destroyed() {
    clearInterval(this.timer);
  }
};
</script>

<style lang="less" rel="stylesheet/less">
.login {
  &-content {
    width: 500px;
    min-height: 380px;
    padding: 20px 60px;
    box-sizing: border-box;
    float: right;
    box-shadow: 0px 2px 32px 0px rgba(102, 102, 102, 0.1);
    .el-tabs__content {
    }
    iframe {
      width: 100%;
      height: 400px;
    }
  }
}
.register {
  width: 1200px;
  margin: -40px auto 0 auto;
  display: flex;
  justify-content: center;
  height: 100%;
  align-items: center; /*垂直居中*/
  .login-left {
    width: 520px;
    height: 424px;
    background: url("../../assets/images/sign_img.png") no-repeat center center;
    /*background-size: 80% 80%;*/
  }
  &-title {
    text-align: center;
    font-weight: 400;
  }
  &-form {
    &-wraper {
      margin-top: 20px;
    }
    .el-form-item {
      border-bottom: 1px solid #ddd;
      .el-input__inner {
        border: 0;
      }
      .el-input-group__append {
        background: none;
        border: 0;
        padding: 0;
        cursor: pointer;
        .el-button--text {
          color: #1e88e5;
          width: 160px;
          span {
            border-left: 1px solid #ddd;
            padding-left: 20px;
          }
          i {
            font-style: normal;
          }
        }
      }
    }
    &-btn {
      border-radius: 0;
      width: 100%;
      margin-top: 15px;
      height: 36px;
      padding: 10px 20px;
    }
    &-des {
      text-align: center;
      font-size: 14px;
      margin-top: 15px;
    }
  }
}
</style>
